const Form062PICSEN = {
    picsTitle: "Personal Information Collection Statement",
    subtitleList: [
        { text: "Purpose of Collection" },
        { text: "Classes of Transferees" },
        { text: "Access to Personal Data" },
    ],
    symbolStep: [{ step: "(a)" }, { step: "(b)" }, { step: "(c)" }],
    firstStep: [
        {
            text: "The  personal  data  provided  by  you  in  this  form  will  be  used  by  the  Education  Bureau  (EDB)  for  activities  as  mentioned  in  the prevailing  EDB  Circular  on  Trading  Operations  in  Schools,  and  the  administration  and  enforcement  of  relevant  educational  rules  and regulations including the Education Ordinance (Cap. 279).",
        },
        {
            text: "The provision of personal data required by this form and during the processing of this form is obligatory.    In the event that you do not provide those personal data, we may not be able to handle or further process the form.",
        },
        {
            text: "The  personal  data  you  provide  will  be  made  available  to  persons  working  in  EDB.     Apart  from  this,  they  may  be  transferred  or disclosed to the parties or in the circumstances listed below:-",
        },
        {
            text: "You  have  the  right  to  request  access  to  and  correction  of  your  personal  data  held  by  EDB.     Request  for  access  or  correction  of personal data should be made in writing to the respective Senior School Development Officer of Regional Education Office (REO) (For the addresses of the REOs, please refer to the EDB webpage (path: <a href='https://www.edb.gov.hk/en/index.html' target='_blank'>www.edb.gov.hk</a> > Contact Us > Regional Education Offices).",
        },
    ],
    secondStep: [],
    thirdStep: [
        {
            text: "other Government bureau and departments, for the purposes mentioned in paragraph 1 above; ",
        },
        {
            text: "where you have given your prescribed consent to such disclosure; and",
        },
        {
            text: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
    ],
};
export default Form062PICSEN;
